import { cn } from "@newxsystems/shared";
import { VelvetCommonContent } from "../../../../modules/content/components/VelvetCommonContent/VelvetCommonContent";
import { VelvetMedia } from "../../../../modules/content/components/VelvetMedia/VelvetMedia";
import { VelvetSection } from "../../../../modules/content/components/VelvetSection/VelvetSection";
import { VideoPlayer } from "../../../../modules/content/components/VideoPlayer/VideoPlayer";
import type { ITextMediaBlockProps } from "./TextMediaBlock.props";

export const TextMediaBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  direction,
  eyebrow,
  heading,
  image,
  parentClass,
  spacing,
  video,
}: ITextMediaBlockProps) => {
  const videoDestination =
    video?.source === "direct"
      ? video.directVideo
      : video?.source === "youtube"
        ? video.youtubeVideo
        : video?.vimeoVideo;
  const hasCopy = Boolean(eyebrow || heading || description || buttons?.length);
  if (!image && !videoDestination) return null;
  const media = (
    <div className="flex min-w-0 flex-col gap-3">
      {image ? (
        <VelvetMedia
          aspectRatio={image.aspectRatio || "16:9"}
          className="velvet-arch border border-parchment/20"
          media={image.image}
          sizes="(min-width: 768px) 50vw, 100vw"
        />
      ) : null}
      {video && videoDestination ? (
        <VideoPlayer
          banner={video.banner}
          directVideo={video.directVideo}
          source={video.source}
          vimeoVideo={video.vimeoVideo}
          youtubeVideo={video.youtubeVideo}
        />
      ) : null}
    </div>
  );
  return (
    <VelvetSection className={parentClass} id={anchorId} spacing={spacing}>
      {hasCopy ? (
        <div className="grid items-center gap-10 md:grid-cols-12 md:gap-6">
          <div
            className={cn(
              "order-1 flex min-w-0 items-center md:col-span-5 md:px-6",
              direction === "ltr" && "md:order-2 md:col-start-8",
            )}
          >
            <VelvetCommonContent
              alignment={alignment}
              buttons={buttons}
              description={description}
              eyebrow={eyebrow}
              heading={heading}
            />
          </div>
          <div
            className={cn(
              "order-2 min-w-0 md:col-span-7",
              direction === "ltr" ? "md:order-1 md:col-start-1" : "md:col-start-6",
            )}
          >
            {media}
          </div>
        </div>
      ) : (
        <div className="mx-auto max-w-[66rem] border-y border-parchment/20 py-4">{media}</div>
      )}
    </VelvetSection>
  );
};

TextMediaBlock.displayName = "Block::TextMediaBlock";
